import { defineStore } from "pinia";

export const useMyBookingStore = defineStore("myBooking", {
  persist: false,
  state: () => ({
    lastName: undefined,
    bookingCode: undefined,
    bookingJwt: undefined,
    reservationCode: undefined,
    reservationJwt: undefined,
    reservationJwtList: [],
    showNavigation: true,
    paymentData: {
      forBooking: false,
      forReservation: false,
      bookingInfo: null,
      reservationInfo: null,
      type: "fullAmount",
      travelData: {},
      totalGuests: 1,
      numberOfRooms: 1,
    },
  }),
});
